<template>
    <div>
        <div>
            <md-card style="margin-bottom: 15px">
                <md-card-header>
                    <div class="md-layout">
                        <div class="md-layout-item">
                            <h1 class="md-title">Quotes</h1>
                        </div>

                        <div class="md-layout-item" style="text-align-last: right">
                            <md-button
                                class="md-fab md-mini md-primary"
                                @click="showCreateNewQuote2()"
                                style="color: black"
                            >
                                <md-icon>add</md-icon>
                            </md-button>
                        </div>
                    </div>
                    <div>
                        <md-field>
                            <md-input
                                v-model="quoteSearchFilter.lead_name"
                                v-debounce:300ms="searchQuotes"
                                placeholder="Zoek op naam..."
                                type="text"
                            />
                        </md-field>
                    </div>
                </md-card-header>
                <md-card-content>
                    <md-checkbox
                        v-model="quoteStatusCreatedChecked"
                        @change="checkboxStatusClicked(QuoteStatus.created, quoteStatusCreatedChecked)"
                        >Created
                    </md-checkbox>
                    <md-checkbox
                        v-model="quoteStatusApprovedChecked"
                        @change="checkboxStatusClicked(QuoteStatus.approved, quoteStatusApprovedChecked)"
                        >Approved
                    </md-checkbox>
                    <md-checkbox
                        v-model="quoteStatusCancelledChecked"
                        @change="checkboxStatusClicked(QuoteStatus.cancelled, quoteStatusCancelledChecked)"
                        >Cancelled
                    </md-checkbox>
                </md-card-content>
            </md-card>
        </div>

        <div>
            <md-card v-for="quote in quoteList" :key="quote.quote_id" style="margin-bottom: 15px; cursor: pointer">
                <md-card-header>
                    <div class="md-layout md-gutter md-alignment-top-right">
                        <div class="md-layout-item" @click="toggleQuoteDetail(quote)">
                            <!--toggleQuoteDetail(quote) -->
                            <div class="md-subheading md-layout-item md-layout">
                                <div>
                                    <md-icon v-if="!quote.showDetail">expand_more</md-icon>
                                    <md-icon v-if="quote.showDetail">expand_less</md-icon>
                                </div>
                                Quote ID:
                                {{ quote.quote_id }}
                                <md-badge
                                    v-if="quote.status === QuoteStatus.created"
                                    class="md-square"
                                    md-content="Created"
                                />
                                <md-badge
                                    v-if="quote.status === QuoteStatus.approved"
                                    class="md-square"
                                    md-content="Approved"
                                    style="background-color: #4de473"
                                />
                                <md-badge
                                    v-if="quote.status === QuoteStatus.cancelled"
                                    class="md-square"
                                    md-content="Cancelled"
                                    style="background-color: #e40007; color: white"
                                />
                            </div>

                            <div class="md-subhead">
                                {{
                                    quote.data.quote_create
                                        ? quote.data.quote_create.clientFiche.first_name +
                                          ' ' +
                                          quote.data.quote_create.clientFiche.last_name +
                                          ' - '
                                        : quote.client.client_data.first_name +
                                          ' ' +
                                          quote.client.client_data.last_name +
                                          ' - '
                                }}
                                <span
                                    >{{ quote.creation_date | formatDate }}
                                    <star-rating
                                        style="display: inline-block; margin-left: 15px"
                                        :rating="quote.data.rating ? quote.data.rating.value : 0"
                                        :read-only="true"
                                        :max-rating="quote.data.rating ? quote.data.rating.max : 5"
                                        :show-rating="false"
                                        :star-size="10"
                                    ></star-rating
                                ></span>
                            </div>
                        </div>

                        <div class="md-layout-item" style="text-align: right; max-width: 150px">
                            <md-button
                                v-if="quote.pdf_raw === QUOTE_PDF_RAW_PLACEHOLDER"
                                @click="downloadQuote(quote.quote_id)"
                                class="md-raised md-dense md-icon-button md-layout-item"
                            >
                                <md-icon>arrow_downward</md-icon>
                            </md-button>
                            <md-button
                                :disabled="quote.status !== QuoteStatus.created"
                                @click="showEditMode(quote)"
                                class="md-raised md-dense md-icon-button md-layout-item"
                            >
                                <md-icon>edit</md-icon>
                            </md-button>

                            <md-button
                                :disabled="quote.status !== QuoteStatus.created"
                                @click="showCancelQuote(quote.quote_id)"
                                class="md-raised md-dense md-icon-button md-layout-item"
                            >
                                <md-icon>clear</md-icon>
                            </md-button>
                        </div>
                    </div>
                </md-card-header>

                <md-card-content v-if="quote.showDetail">
                    <md-button @click="showCommentDialog(quote.quote_id)" class="md-dense md-raised md-primary">
                        Add comment
                        <!--   <md-icon>comment</md-icon>-->
                    </md-button>

                    <md-list v-if="quote.comments" class="md-triple-line">
                        <div v-for="(comment, index) in quote.comments" :key="index">
                            <md-list-item>
                                <div class="md-list-item-text">
                                    <span>{{
                                        comment.created_by_user.first_name + ' ' + comment.created_by_user.last_name
                                    }}</span>
                                    <span style="color: rgba(0, 0, 0, 0.34); font-size: 11px"
                                        ><hour-display
                                            :date-time="comment.creation_date"
                                            date-time-format="DD/MM/YYYY HH:mm:ss"
                                    /></span>
                                    <p>{{ comment.data.comment }}</p>
                                </div>
                            </md-list-item>

                            <md-divider></md-divider>
                        </div>
                    </md-list>
                </md-card-content>
            </md-card>
        </div>
        <div>
            <div class="center" v-if="quoteList.length > 0">
                <div class="pagination">
                    <div class="page-item">
                        <a aria-label="Previous" class="page-link" @click="setPage(currentPageIndex - 1)">
                            <!--<md-icon>arrow_back_ios</md-icon>-->
                            <template>Prev</template>
                        </a>
                    </div>
                    <!--<li style="align-self: flex-end;" v-if="currentPageIndex > 3">...</li>-->
                    <div v-for="pageNo in maxPages" :key="pageNo" class="page-item">
                        <a
                            v-if="pageNo >= currentPageIndex - 2 && pageNo <= currentPageIndex + 2"
                            class="page-link"
                            v-bind:class="{ active: pageNo === currentPageIndex + 1 }"
                            @click="setPage(pageNo - 1)"
                        >
                            {{ pageNo }}
                        </a>
                    </div>
                    <!--<li style="align-self: flex-end;" v-if="currentPageIndex < maxPages -2">...</li>-->
                    <div class="page-item" v-bind:class="{ disable: currentPageIndex + 1 !== this.maxPages }">
                        <a
                            v-if="currentPageIndex + 1 !== this.maxPages"
                            aria-label="Next"
                            class="page-link"
                            @click="setPage(currentPageIndex + 1)"
                        >
                            <template>Next</template>
                        </a>
                    </div>
                </div>
                <div>
                    <span style="color: #ff9800">
                        {{
                            currentPageSize * (currentPageIndex + 1) -
                            currentPageSize +
                            1 +
                            ' - ' +
                            currentPageSize * (currentPageIndex + 1) +
                            ' of ' +
                            maxPages * currentPageSize
                        }}
                    </span>
                </div>
            </div>
        </div>
        <md-dialog :md-active.sync="showCancel">
            <md-dialog-title>Cancel Quote</md-dialog-title>

            <md-dialog-content> Ben je zeker dat je quote wilt annuleren? </md-dialog-content>

            <md-dialog-actions>
                <md-button class="md-primary" @click="cancelCancelQuote()">No</md-button>
                <md-button class="md-primary" @click="cancelQuote()">Yes</md-button>
            </md-dialog-actions>
        </md-dialog>

        <!-- Todo make this a reusable component => also used in quote comment-->
        <md-dialog :md-active.sync="showComment">
            <md-dialog-title>Comment</md-dialog-title>

            <md-dialog-content>
                <md-field>
                    <label for="comment">Comment</label>
                    <md-textarea id="comment" name="comment" v-model="comment.data.comment"> </md-textarea>
                </md-field>
            </md-dialog-content>

            <md-dialog-actions>
                <md-button @click="cancelComment()" class="md-primary">Cancel</md-button>
                <md-button @click="addComment()" class="md-primary">Add comment</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { QuoteServiceApi } from '@/resources/phrospr-api/quote.service';
import * as toastr from 'toastr';
import router from '@/router';
import ClientSearchModal from '@/components/client-search-modal/ClientSearchModal.vue';
import HourDisplay from '@/components/utils/HourDisplay.vue';
import {
    ICommentEntity,
    IQuoteEntity,
    IQuoteSearchEntity,
    IQuoteSearchFilterEntity,
    QuoteApi,
    QuoteCommentApi,
    QuoteStatus,
} from '@phrospr/api-backend';
import StarRating from 'vue-star-rating';
import { downloadFileFromApi } from '@phrospr/lib-web-core';
import { PDF_RAW_PLACEHOLDER } from '@phrospr/lib-models';

export interface QuoteOverViewQuote extends IQuoteEntity {
    showDetail?: boolean;
}

@Component({
    components: {
        ClientSearchModal,
        HourDisplay,
        StarRating,
    },
    beforeRouteEnter: async function (to, from, next) {
        try {
            next((component: QuoteOverview) => component.setPage(0));
        } catch (err) {
            console.error(err);
        }
    },
})
export default class QuoteOverview extends Vue {
    QUOTE_PDF_RAW_PLACEHOLDER = PDF_RAW_PLACEHOLDER;
    quoteList: Array<QuoteOverViewQuote> = [];

    quoteSearchCore: IQuoteSearchEntity = {
        limit: 10,
        offset: 10,
    };

    quoteSearchFilter: IQuoteSearchFilterEntity = {
        quote_states: [QuoteStatus.approved, QuoteStatus.created, QuoteStatus.cancelled],
        lead_name: '',
    };

    quoteStatusCreatedChecked: boolean = true;
    quoteStatusApprovedChecked: boolean = true;
    quoteStatusCancelledChecked: boolean = true;

    public QuoteStatus = QuoteStatus;

    currentPageSize = 10;
    currentPageIndex = 1;
    maxPages = 1;

    showCancel: boolean = false;
    quoteIdToCancel: number;

    showComment: boolean = false;
    comment: ICommentEntity = {
        data: {
            comment: '',
            contacted_info: {},
        },
        comment_id: null,
        creation_date: null,
        created_by_user_id: null,
    };
    quoteIdToAddComment: number;

    constructor() {
        super();
        this.$store.commit('setQuoteCreateSettings', null);
    }

    public checkboxStatusClicked(value: QuoteStatus, checked: boolean) {
        if (checked === true) {
            this.quoteSearchFilter?.quote_states?.push(value);
        } else {
            let index = this.quoteSearchFilter?.quote_states?.indexOf(value);
            this.quoteSearchFilter?.quote_states?.splice(index, 1);
        }
        this.searchQuotes();
    }

    searchQuotes() {
        this.setPage(0);
    }

    public async getQuotes(lead_name?: string, quoteStates?: QuoteStatus[], quoteSearchCore?: IQuoteSearchEntity) {
        try {
            const quotes = await QuoteServiceApi.getRawQuotes(
                undefined,
                undefined,
                undefined,
                true,
                lead_name,
                quoteStates,
                undefined,
                quoteSearchCore,
            );
            this.quoteList = quotes.records;
            this.maxPages = Math.ceil(quotes.total / this.currentPageSize);
        } catch (e) {
            console.log(e);
            toastr.error('Something went wrong with server call to retrieve the quotes');
        }
    }

    public async downloadQuote(quote_id: number) {
        try {
            await downloadFileFromApi(await QuoteApi.downloadQuote(quote_id, { responseType: 'blob' }));
        } catch (e) {
            console.error(e);
            toastr.error('Something went wrong with server call');
        }
    }

    showCancelQuote(quote_id: number) {
        this.showCancel = true;
        this.quoteIdToCancel = quote_id;
    }

    cancelCancelQuote() {
        this.showCancel = false;
        this.quoteIdToCancel = null;
    }

    public async cancelQuote() {
        try {
            await QuoteApi.cancelQuote(this.quoteIdToCancel);
            this.showCancel = false;
            this.setPage(this.currentPageIndex);
        } catch (e) {
            toastr.error('Something went wrong with server call');
        }
    }

    public showEditMode(quote: IQuoteEntity) {
        if (quote.status !== QuoteStatus.created) {
            return toastr.error('Quote is al goed gekeurd door klant, kan dit niet meer wijzigen');
        }

        this.$store.commit('setQuoteCreateSettings', {
            quote_id: quote.quote_id,
            editMode: true,
            client_id: quote.client_id,
        });
        if (quote.data && quote.data.quote_create) {
            return router.push({ path: `/quote` });
        } else {
            return router.push({ path: `/quote2/upsert/${quote.quote_id}` });
        }

        router.push({ path: `/quote/overview` });
    }

    public async showCreateNewQuote() {
        await router.push({ path: '/quote/new' });
    }
    public async showCreateNewQuote2() {
        await router.push({ path: '/quote2/upsert' });
    }

    public async toggleQuoteDetail(quote: QuoteOverViewQuote) {
        quote.showDetail = !quote.showDetail;
        this.$mount();
        if (quote.showDetail) await this.loadQuoteComments(quote);
    }

    public async loadQuoteComments(quote: QuoteOverViewQuote) {
        try {
            quote.comments = (await QuoteCommentApi.listQuoteComments(quote.quote_id)).data;
            quote.comments.sort((a, b) => (b.comment_id ?? 0) - (a.comment_id ?? 0));
            this.$mount();
        } catch (e) {
            console.log(e);
        }
    }

    public async setPage(pageIndex: number) {
        if (pageIndex < 0) return;
        if (pageIndex > this.maxPages - 1 && pageIndex < 0)
            return console.log('page to high', pageIndex, this.maxPages);
        this.currentPageIndex = pageIndex;

        this.quoteSearchCore = {
            limit: this.currentPageSize,
            offset: this.currentPageSize * this.currentPageIndex,
            filter: this.quoteSearchFilter,
        };

        await this.getQuotes(
            this.quoteSearchCore?.filter?.lead_name,
            this.quoteSearchCore?.filter?.quote_states,
            this.quoteSearchCore,
        );
    }

    public async addComment() {
        if (this.comment.data.comment != '') {
            try {
                await QuoteCommentApi.addQuoteComment(this.quoteIdToAddComment, {
                    ...this.comment,
                    creation_date: new Date(),
                    created_by_user: undefined,
                    comment_id: null,
                    created_by_user_id: null,
                });
                this.showComment = false;
                this.comment.data.comment = '';
                toastr.success('commentaar geregistreerd');
                const quote = this.quoteList.find(x => x.quote_id === this.quoteIdToAddComment);
                if (quote) await this.loadQuoteComments(quote);
            } catch (e) {
                console.log(e);
                toastr.error('er ging iets mis in het registreren van de comment');
            }
        } else {
            toastr.error('commentaar is leeg');
        }
    }

    public showCommentDialog(quote_id: number) {
        this.showComment = true;
        this.quoteIdToAddComment = quote_id;
    }

    public cancelComment() {
        this.showComment = false;
        this.quoteIdToAddComment = null;
        this.comment.data.comment = '';
    }
}
</script>

<style scoped>
.align-right {
    text-align: right;
}

.md-badge {
    position: relative;
}

.quote-edit-disabled.md-button {
    background: rgba(0, 0, 0, 0.1);
}

.md-button[disabled] {
    opacity: 0.5;
}

.md-card-header {
    padding: 8px;
}

.center {
    text-align: center;
    width: 100%;
}

.pagination {
    border-radius: 0.25rem;
    display: inline-flex;
    padding: 2px;
}

.page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: 0;
    line-height: 1.25;
    color: #2196f3;
    background-color: transparent;
    border: 0 solid #dee2e6;
    cursor: pointer;
}

.pagination a span {
    border: 0;
    transition: all 0.3s;
    margin: 0 3px;
    padding: 0;
    min-width: 30px;
    height: 30px;
    line-height: 30px;
    text-transform: uppercase;
    background: transparent;
    text-align: center;
    cursor: pointer;
}

.pagination a.active {
    border-radius: 30px !important;
    background-color: #ff9800;
    border-color: #ff9800;
    color: #fff !important;
    box-shadow: 0 4px 5px 0 rgba(255, 152, 0, 0.14), 0 1px 10px 0 rgba(255, 152, 0, 0.12),
        0 2px 4px -1px rgba(255, 152, 0, 0.2);
}
</style>
